/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.result-text[_ngcontent-%COMP%]{color:#fff;padding-left:5px;padding-right:5px}.form-control[_ngcontent-%COMP%], .input-group-btn[_ngcontent-%COMP%]{width:auto}.search-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{padding-right:10px}input.search[_ngcontent-%COMP%]{min-width:300px}.pull-left[_ngcontent-%COMP%]{float:left}.inline[_ngcontent-%COMP%]{display:inline-block}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3JlY29yZC1lZGl0b3Ivc2VhcmNoLWJhci9zZWFyY2gtYmFyLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3JlY29yZC1lZGl0b3Ivc2VhcmNoLWJhci9zZWFyY2gtYmFyLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/record-editor/search-bar/search-bar.component.scss.shim.ngstyle.ts